import * as React from "react";
import SliderNavigation from "../Common/Slider/Navigation";
import Slider from "../Common/Slider";
import Section from "../Layout/Section";
import Link from "../UI/Link";
import Media from "../Common/Media";
import * as styles from "./products.module.css";
import TemplateString from "../Common/TemplateString";

const Products = ({title, description, products}) => {
    return (
        <Section>
            <Slider
                title={title}
                desc={description}
                navigation={<SliderNavigation />}
                sliderClassName={styles.products__slider}
                containerClassName={styles.products__sliderContainer}
                titleClassName={styles.products__sliderTitle}
            >
                {products.map(({id, name, description: desc, link, image}) => (
                    <div key={id}>
                        <div className={styles.products__card}>
                            <div>
                                <h3 className={styles.products__cardTitle}>
                                    <TemplateString template={name} />
                                </h3>
                                <p className={styles.products__cardDesc}>
                                    <TemplateString template={desc} />
                                </p>
                            </div>
                            <div>
                                <Link to={link} withArrow className={styles.products__cardLink}>
                                    Подробнее
                                </Link>
                                <Media media={{content: image}} className={styles.products__cardMedia} />
                            </div>
                            <div className={styles.products__cardGradient} />
                        </div>
                    </div>
                ))}
            </Slider>
        </Section>
    );
};

export default Products;
